import { BenchMaterial } from './saunaparts/BenchMaterial';
import ImageResolution from './saunaparts/ImageResolution';
import { PanelMaterial } from './saunaparts/PanelMaterial';
import { BenchModel } from './saunaparts/BenchModel';
import { Stove } from './saunaparts/Stove';
import { Stool } from './saunaparts/Stool';
const fallBackModels = new Map<string, string>();
fallBackModels.set("basic", "classic");
fallBackModels.set("relaxxl", "relax");


export class LayerImageRepository {
    rootPath: string;
    imageExtension: string;
    avalaiableResolutions: ImageResolution[];
    constructor(rootPath: string, avalaiableResolutions: Array<ImageResolution>, imageExtension: string="png") {
        this.rootPath = rootPath;
        this.avalaiableResolutions = avalaiableResolutions;
        this.imageExtension = imageExtension;
    }

    getPanelLayer(material: PanelMaterial, saunaSize: string, resolution: ImageResolution): string {
        return this.getRootFolder(resolution) + "panel/" + saunaSize + "_paneeli_" + "vaaka" + "_" + material.widthCode + "." + this.imageExtension;
    }
    getBenchBackrestFiberLightLayer(benchModel:BenchModel,resolution:ImageResolution)
    {
        var bencModelName = benchModel?benchModel.name:"0000";        
        return this.getRootFolder(resolution) +"benchLight/"+ bencModelName+"." + this.imageExtension;
    };
    getBenchBackrestLinearBarLightLayer(benchModel:BenchModel,resolution:ImageResolution): string
    {
        var bencModelName = benchModel?benchModel.name:"0000";        
        return this.getRootFolder(resolution) + "benchLight/" + bencModelName +"_LINEARBACKREST." + this.imageExtension;
    };
    getLowerBenchinearBarLightLayer(benchModel:BenchModel,benchProductLine:BenchProductLine,resolution:ImageResolution):string
    {
        return this.getRootFolder(resolution) +"benchLight/" +benchProductLine.name.toUpperCase()+"_"+benchModel.name+"_LINEARBOTTOMBENCH." + this.imageExtension;

    }
    getRoofLigthLayer(benchModel:BenchModel,resolution:ImageResolution):string
    {
        return this.getRootFolder(resolution) +"roofLight/" +benchModel.name+"." + this.imageExtension;
    };

    getBenchBaseLayer(benchModel:BenchModel,benchProductLine:BenchProductLine,benchMaterial:BenchMaterial,resolution:ImageResolution): string
    {
       return this.getRootFolder(resolution) +"basebenchimages/"+benchModel.size+"/laude_"+benchProductLine.name+benchMaterial.widthCode+"_"+benchMaterial.materialName+"_"+benchModel.name+"." + this.imageExtension;
    };
    getBenchShadowImageLayer(benchModel:BenchModel,benchProductLine:BenchProductLine,benchMaterial:BenchMaterial,resolution:ImageResolution): string
    {
        let productLineName = benchProductLine.name;
       if(productLineName==="wave" || productLineName ==="elegance")
       {
           productLineName="wave_elegance";
       }
       var widthCode =benchMaterial.widthCode;
       if(productLineName === "relax" && (benchModel.size ==="max" || benchModel.size==="spc1" || benchModel.size === "spc2"))
       {
           widthCode="";
       }
       
       return this.getRootFolder(resolution) +"basebenchimages/"+benchModel.size+"/laude_"+productLineName+widthCode+"_varjo_"+benchModel.name+"." + this.imageExtension;
    };
    getBenchProfileLayer(benchModel:BenchModel,benchProductLine:BenchProductLine,resolution:ImageResolution): string
    {
       let productLineName = benchProductLine.name;
       if(productLineName==="wave" || productLineName ==="elegance")
       {
           productLineName="wave_elegance";
       }
       return this.getRootFolder(resolution) +"basebenchimages/"+benchModel.size+"/laude_"+productLineName+"_ritilat_"+benchModel.name+"." + this.imageExtension;
    };
    getMetalPartsLayer(benchModel: BenchModel, benchProductLine: BenchProductLine, resolution: ImageResolution) {
        return this.getRootFolder(resolution) + "basebenchimages/" + benchModel.size + "/metalliosat_" + benchProductLine.name + "_" + benchModel.name + "." + this.imageExtension;


    }


    getFloorLayer(size:string,resolution:ImageResolution)
    {
      return this.getRootFolder(resolution)+ "floor/"+size+"_lattia." + this.imageExtension;
    };
    getStoveLayer(benchModel:BenchModel,benchProductLine:BenchProductLine,light:boolean,stove:Stove,resolution:ImageResolution):string
    {
        var productLineName = benchProductLine?.name || "classic";
        var bencModelName = benchModel?benchModel.name:"0000";
        var lightPart = "";
        if(light)
        {
            lightPart="valo_";
        }
        productLineName = fallBackModels.get(productLineName) || productLineName;
      if (productLineName === "wave" || productLineName === "elegance")
       {
           productLineName="wave_elegance";

       }
        if (benchModel?benchModel.useCommonStove:false) {
            productLineName = "common";
        } 
        return this.getRootFolder(resolution) + "stoves/" + productLineName + "/kiuas_" + stove.layerId +"_"+lightPart+bencModelName+"." + this.imageExtension;
    };

    getglassWallLayer(benchModel:BenchModel,fullHeightGlassWall:boolean,resolution:ImageResolution)
    {
        let layerName:string;
        if (benchModel) {
            if (fullHeightGlassWall) {
                layerName = benchModel.fullHeightGlassImage + "." + this.imageExtension;
            }
            else {
                layerName = benchModel.halfHeightGlassImage + "." + this.imageExtension;
            }
        }
        else layerName = "min_lasiseina2." + this.imageExtension;
        return this.getRootFolder(resolution) +"glassWall/"+layerName;
    };
    getStoolLayerName(stool: Stool, layerType: string) {
        let name = stool.Model.LayerName + "_" + layerType+"_" + stool.MaterialName;
        if (stool.Model.HasWidhtAndBoarNumber)
            name += "_" + stool.MaterialWidth + "_" + stool.BoardNumber;
        name += ".png";
        return name;
    }
    getStoolBackgroundLayer(stool: Stool, resolution: ImageResolution) {
        let name = this.getRootFolder(resolution) + "stool/" + stool.Model.LayerName + "_tausta";
        if (stool.Model.HasWidhtAndBoarNumber)
            name += "_" + stool.MaterialWidth + "_" + stool.BoardNumber;
        name += ".png";
        return name;
    }
    getStoolBoardingLayer(stool: Stool, resolution: ImageResolution) {
        return this.getRootFolder(resolution) + "stool/" + this.getStoolLayerName(stool, "istuin");
    }
    getStoolHeadboardLayer(stool: Stool, resolution: ImageResolution) {
        return this.getRootFolder(resolution) + "stool/" + this.getStoolLayerName(stool,"runko");
    }
    getStoolLegLayer(stool: Stool, resolution: ImageResolution) {
        let name = this.getRootFolder(resolution) + "stool/" + stool.Model.LayerName + "_jalat"
        if (stool.Model.HasLegMaterialLayer) {
            name += "_" + stool.MaterialName;
        } 
        if (stool.Model.HasWidhtAndBoarNumber)
            name += "_" + stool.MaterialWidth + "_" + stool.BoardNumber;
        name += ".png";
        return name;
    }

    getRootFolder(resolution: ImageResolution) {
        var resolutionPath = "";
       resolutionPath = this.getResolution(resolution);  
        return this.rootPath + resolutionPath + "/";
    }
    getResolution(desiredResolution: ImageResolution): string {
        let suitapleResolutions = this.avalaiableResolutions.
            filter(r => r.height >= desiredResolution.height && r.width >= desiredResolution.width).
            sort((a, b) => b.width * b.height - a.width * a.height).
            reverse();
        let resolution: ImageResolution;
        if (suitapleResolutions.length > 0) {
            resolution = suitapleResolutions[0];
        }
        else {
            resolution = this.avalaiableResolutions.sort(r => r.height * r.width).reverse()[0];
        }
        return resolution.width +"x"+ resolution.height;
    }
}
